import styled from 'styled-components';
import { alpha } from '@mui/material/styles';

const fontFamily = (props) => props.theme?.typography?.body1?.fontFamily || '"Poppins", "Arial", sans-serif';

const tooltipRestTransform = (alignRight) => (
  alignRight ? 'translate3d(0, 6px, 0)' : 'translate3d(-50%, 6px, 0)'
);

const tooltipActiveTransform = (alignRight) => (
  alignRight ? 'translate3d(0, 0, 0)' : 'translate3d(-50%, 0, 0)'
);

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: visible;

  &:hover > span,
  &:focus-within > span {
    opacity: ${(props) => (props.$suppress ? 0 : 1)};
    visibility: ${(props) => (props.$suppress ? 'hidden' : 'visible')};
    transform: ${(props) => (
    props.$suppress
      ? tooltipRestTransform(props.$alignRight)
      : tooltipActiveTransform(props.$alignRight)
  )};
  }
`;

export const Tooltip = styled.span`
  position: absolute;
  top: calc(100% + 10px);
  left: ${(props) => (props.$alignRight ? 'auto' : '50%')};
  right: ${(props) => (props.$alignRight ? '0' : 'auto')};
  transform: ${(props) => tooltipRestTransform(props.$alignRight)};
  background-color: ${(props) => props.theme.palette.background.paper};
  color: ${(props) => props.theme.palette.text.primary};
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.palette.border?.subtle};
  font-size: var(--font-caption);
  font-weight: 500;
  letter-spacing: 0.01em;
  line-height: 1.25;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition:
    opacity 0.18s cubic-bezier(0.22, 1, 0.36, 1),
    transform 0.18s cubic-bezier(0.22, 1, 0.36, 1),
    visibility 0.18s linear;
  transition-delay: 0.04s;
  z-index: ${(props) => props.$zIndex ?? 10011};
  font-family: ${fontFamily};
  box-shadow:
    0 1px 2px ${(props) => alpha(props.theme.palette.text.primary, 0.04)},
    0 8px 20px ${(props) => alpha(props.theme.palette.text.primary, props.$elevated ? 0.12 : 0.08)};
`;
